import { render, staticRenderFns } from "./RiskFactSelector.vue?vue&type=template&id=42f333cb&scoped=true"
import script from "./RiskFactSelector.vue?vue&type=script&lang=js"
export * from "./RiskFactSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f333cb",
  null
  
)

export default component.exports